export default __webpack_public_path__ + "slices/main/assets/public/media/logo-bar-slack@2x.8cb794339bca69db0c6b4b0a74d5da88.png";